import React from 'react'
import {Modal, ModalHeader, ModalBody} from 'reactstrap'
import YourReservationBlue from "../RentalCars/YourReservationBlue"

export default class SeoSearchModal extends React.Component {

    constructor(props) {
        super(props)
        this.state = {open: false}
        this.layoutMobile = window.innerWidth < MAX_WIDTH
    }

    componentDidMount() {
        window.addEventListener('toggleModal', this.toggle);
    }

    componentWillUnmount() {
        window.removeEventListener('toggleModal', this.toggle);
    }

    toggle = () => {
        this.setState({open: !this.state.open})
    }

    render() {
        return (
            <Modal size={'lg'} isOpen={this.state.open} toggle={this.toggle} className={'modalCentered'}>
                <ModalHeader toggle={this.toggle} className={''}>
                    {this.props.t.your_res}
                </ModalHeader>
                <ModalBody className={'modalBodyRoundBottom'}>
                    <YourReservationBlue {...this.props} layoutMobile={this.layoutMobile} staticPage/>
                </ModalBody>
            </Modal>
        )
    }

}